import React from 'react';
import { CloseButton, Container, Link } from './styles';
import BatchHeader from './BatchHeader';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { X as Close } from '@styled-icons/bootstrap/X';
import Tooltip from '../Tooltip';
const TextContainer = styled.div `
  font-size: 14px;
  margin-top: 8px;
`;
const NoDataContainer = ({ isMobile, infoMessage, rawMaterialTitle, onGoToFirstBatchDataStep, onClose, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, { isMobile: isMobile },
        React.createElement(BatchHeader, { hideLocationPin: true, rawMaterialTitle: rawMaterialTitle }),
        !!onClose && (React.createElement(CloseButton, { onClick: onClose },
            React.createElement(Tooltip, { tooltipText: t('close-batch-tracing-tooltip') },
                React.createElement(Close, { width: 24 })))),
        React.createElement(TextContainer, null,
            infoMessage,
            ". \u00A0",
            !!onGoToFirstBatchDataStep && (React.createElement(Link, { onClick: onGoToFirstBatchDataStep }, t('jump-to-batch-data'))))));
};
export default NoDataContainer;
